var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoundNone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5 4C10.3783 4 8.34344 4.84285 6.84315 6.34315C5.34285 7.84344 4.5 9.87827 4.5 12C4.5 13.0506 4.70693 14.0909 5.10896 15.0615C5.511 16.0321 6.10028 16.914 6.84315 17.6569C7.58601 18.3997 8.46793 18.989 9.43853 19.391C10.4091 19.7931 11.4494 20 12.5 20C13.5506 20 14.5909 19.7931 15.5615 19.391C16.5321 18.989 17.414 18.3997 18.1569 17.6569C18.8997 16.914 19.489 16.0321 19.891 15.0615C20.2931 14.0909 20.5 13.0506 20.5 12C20.5 9.87827 19.6571 7.84344 18.1569 6.34315C16.6566 4.84285 14.6217 4 12.5 4ZM5.42893 4.92893C7.3043 3.05357 9.84784 2 12.5 2C15.1522 2 17.6957 3.05357 19.5711 4.92893C21.4464 6.8043 22.5 9.34784 22.5 12C22.5 13.3132 22.2413 14.6136 21.7388 15.8268C21.2362 17.0401 20.4997 18.1425 19.5711 19.0711C18.6425 19.9997 17.5401 20.7362 16.3268 21.2388C15.1136 21.7413 13.8132 22 12.5 22C11.1868 22 9.88642 21.7413 8.67317 21.2388C7.45991 20.7362 6.35752 19.9997 5.42893 19.0711C4.50035 18.1425 3.76375 17.0401 3.2612 15.8268C2.75866 14.6136 2.5 13.3132 2.5 12C2.5 9.34784 3.55357 6.8043 5.42893 4.92893ZM8.5 12C8.5 11.4477 8.94772 11 9.5 11H15.5C16.0523 11 16.5 11.4477 16.5 12C16.5 12.5523 16.0523 13 15.5 13H9.5C8.94772 13 8.5 12.5523 8.5 12Z",
    fill: "#A6AEBA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundNone);
export default __webpack_public_path__ + "static/media/roundNone.2c831280296ec783b45379c4b53901df.svg";
export { ForwardRef as ReactComponent };